import React, { useEffect, useState } from 'react';
import { useStyles } from './Style';
import createToast from 'components/Toast/Toast';
import { Typography, Grid  } from '@mui/material';
import { Empty, LoadingPage, PaginationComponenets  } from 'components';
import { GrantItem } from './components';
import GrantsServices from './services/GrantsServices';

const Grants = ({ parentCallback, resfreshList }) => {
  const classes = useStyles();

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotoalCount] = useState(0);
  // -- HOOKS --//

  useEffect(() => {
    getGrants();
    paginationOnChange({
      page: currentPage === 0 ? 1 : currentPage,
      pageSize: 5,
      pageNumber: currentPage === 0 ? 0 : currentPage - 1,
      changeData: true,
    });

  }, [currentPage, resfreshList]);

  // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
  const paginationOnChange = async (param) => {
    if (param?.changeData) {
      // صفحه جاری در این بخش ست میش
      setCurrentPage(param?.page == 0 ? 1 : param?.page);
    }
  };

  // -- APIS --//
  const getGrants = async () => {
    setHasError(false);
    try {
      setIsLoading(true);
      const params = {     offset: currentPage === 0 ? 0 : ((currentPage - 1) * 12),
        size:12 }; // TODO: handle pagination
      const result = await GrantsServices.getGrants(params);
      const data = result?.result?.grants;
      setIsLoading(false);
      setList(data);
      setTotoalCount(result?.result?.total)
      parentCallback(data);
    } catch (error) {
      setIsLoading(false);
      createToast('خطا', 'خطا در دریافت اطلاعات', 'danger');
      setHasError(true);
    }
  };

  const hint =
    'در این بخش دسترسی های اعطا شده توسط شما به کسب‌وکارهای دیگر نمایش داده شده است. در صورت لزوم می‌توانید آنها را حذف نمایید.';
  return (
    <div>
      <Typography className={classes.hint}>{hint}</Typography>
      {!isLoading && list ? (
        list.length > 0 ? (
          list.map((v, k) => <GrantItem key={k} data={v} refreshList={getGrants}/>)
        ) : !hasError ? (
          <Empty label="لیست دسترسی‌های اعطا شده خالی است!" />
        ) : null
      ) : null}
      {!isLoading && list?.length > 0 ? (
        <Grid justifyContent="center" container style={{ marginTop: 16 }}>
          <PaginationComponenets
            itemsPerPage={12}
            currentPage={currentPage}
            pageCount={totalCount}
            onChange={paginationOnChange}
            removePrePage={true}
          />
        </Grid>
      ) : null}

      {isLoading ? <LoadingPage /> : null}
    </div>
  );
};


export default Grants;
